import React, { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../context';
import BtxSwitch from '../../../../Forms/BtxSwitch';
import hasPermission from '../../../../Shared/hasPermission';

const SearchPracticePimsToggle = ({ styles = {} }) => {
    // bool tied to the Search Practice Pims toggle in the text search section
    const searchPracticePims = useSelector(state => state.practice.searchPracticePims);

    const dispatch = useDispatch();

    const onChange = useCallback(() => {
        dispatch(actions.practice.setSearchPracticePims(!searchPracticePims))
    }, [searchPracticePims, dispatch]);

    const permissions = useSelector((state) => state.auth.permissions, shallowEqual);
    const can = (permission) => hasPermission(permission, permissions);
    const canSearchActivities = can('SearchActivities');

    if(!canSearchActivities) return [];
    return (
        <BtxSwitch {...styles} onChange={onChange}
            value={searchPracticePims}
            label='Search Practice Pims'
        />
    );
};

export default SearchPracticePimsToggle;
